<template lang="pug">
    .purchase.full-height-error.not-valid(v-if="!enabledExtensions.includes('shop')")
        Error(:message="null" :code="403")
    .purchase.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    //- Multistore: the order exists and this user may see it, but it belongs to a
    //- different store, so it opens there.
    .purchase.full-height-error(v-else-if="foreignStore")
        ForeignStorePanel(
            :store="foreignStore"
            :record-id="$route.params.id"
            record-type="order"
            back-route="purchases"
            @switched="reopenAfterStoreSwitch"
        )
    .purchase.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .purchase(v-else-if="$route.params.id === 'new'")
        NewPurchaseStepper(:loading="loading")
    .purchase(v-else)
        tabs(:items="tabs" :active-tab="activeMessagesTabPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                el-button.cancel-button(
                    circle v-if="! loading && isCancelable"
                    type="danger"
                    icon="el-icon-fa-ban fas"
                    :loading="canceling"
                    :disabled="isDisabledSubmit && ! canceling"
                    @click="cancelPurchaseModalVisibility = true"
                )
                el-button.delete-button(
                    circle v-if="! loading && isCancelable"
                    type="warning"
                    icon="el-icon-fa-undo fas"
                    :loading="partialCanceling"
                    :disabled="isDisabledSubmit && ! partialCanceling"
                    @click="partialCancelPurchaseDrawerVisibility = true"
                )
                el-button.activate-button(
                    circle v-if="! loading && status === 'new' && form.sold_by !== 'point-of-sale'"
                    type="success"
                    icon="el-icon-fa-tasks fas"
                    :disabled="! statusOptionsLoeded"
                    @click="editPurchase"
                )
                //- el-button.activate-button(
                //-     circle v-if="! loading && !inactive && status === 'new' || ! loading && status === 'processing'"
                //-     type="info"
                //-     icon="el-icon-fa-dolly fas"
                //-     :disabled="! statusOptionsLoeded"
                //-     @click="shipPurchase"
                //- )
                template(
                    v-if="(!(['new', 'undefined'].includes(status) && form.sold_by !== 'point-of-sale') || !id || form.canceled_at) && microserviceButtons && microserviceButtons.left && microserviceButtons.left.length"
                    v-for="microservice in microserviceButtons.left"
                )
                    MicroserviceButton(
                        :data="form"
                        :config="microservice"
                        appearance="circle"
                        @error="microserviceError"
                        @success="microserviceSuccess"
                    )
                el-button(
                    circle icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                )
                el-button(
                    circle v-if="! loading && ! inactive"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :disabled="isDisabledSubmit && ! savingAndClose"
                    :loading="savingAndClose"
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle v-if="! loading && ! inactive"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :disabled="isDisabledSubmit && ! saving"
                    :loading="saving"
                    @click="submit"
                )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            all-input-fields
            el-card.no-padding(shadow="always" v-loading="loading")
                router-view.purchase-form(:key="activeMessagesTabPath" :class="{'loading-panel': loading}")
            .buttons-flex
                .form-buttons
                    el-button.cancel-button(
                        round v-if="! loading && isCancelable"
                        type="danger"
                        icon="el-icon-fa-ban fas"
                        :loading="canceling"
                        :disabled="isDisabledSubmit && ! canceling"
                        @click="cancelPurchaseModalVisibility = true"
                    ) {{ $t('Cancel') }}
                    el-button.delete-button(
                        round v-if="! loading && isCancelable"
                        type="warning"
                        icon="el-icon-fa-undo fas"
                        :loading="partialCanceling"
                        :disabled="isDisabledSubmit && ! partialCanceling"
                        @click="partialCancelPurchaseDrawerVisibility = true"
                    ) {{ $t('Partially Cancel') }}
                    el-button.activate-button(
                        round v-if="! loading && status === 'new' && form.sold_by !== 'point-of-sale'"
                        type="success"
                        icon="el-icon-fa-tasks fas"
                        :disabled="! statusOptionsLoeded"
                        @click="editPurchase"
                    ) {{ $t('Edit') }}
                    //- el-button.activate-button(
                    //-     round v-if="! loading && !inactive && status === 'new' || ! loading && status === 'processing'"
                    //-     type="info"
                    //-     icon="el-icon-fa-dolly fas"
                    //-     :disabled="! statusOptionsLoeded"
                    //-     @click="shipPurchase"
                    //- ) {{ $t('Shipped') }}
                    template(
                        v-if="(!(['new', 'undefined'].includes(status) && form.sold_by !== 'point-of-sale') || !id || form.canceled_at) && microserviceButtons && microserviceButtons.left && microserviceButtons.left.length"
                        v-for="microservice in microserviceButtons.left"
                    )
                        MicroserviceButton(
                            :data="form"
                            :config="microservice"
                            @error="microserviceError"
                            @success="microserviceSuccess"
                        )
                .form-buttons
                    el-button(
                        round v-if="! loading"
                        icon="el-icon-fa-times fas"
                        :disabled="isDisabledSubmit"
                        @click="leave"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        round v-if="! loading && ! inactive"
                        type="primary"
                        icon="el-icon-fa-check fas"
                        :loading="savingAndClose"
                        :disabled="isDisabledSubmit && ! savingAndClose"
                        @click="submit($event, listRoute)"
                    ) {{ $t('Save and close') }}
                    el-button(
                        round v-if="! loading && ! inactive"
                        type="success"
                        icon="el-icon-fa-save fas"
                        :loading="saving"
                        :disabled="isDisabledSubmit && ! saving"
                        @click="submit"
                    ) {{ $t('Save') }}

        el-dialog.cancel-purchase-dialog(
            :title="$t('Are you sure you want to cancel this purchase?')"
            :visible.sync="cancelPurchaseModalVisibility"
            :close-on-click-modal="false"
            top="10vh"
            width="600px"
            @closed="resetCancelPurchaseModal"
        )
            el-form.property-modal-form(
                ref="cancelPurchaseForm"
                :model="cancelPurchaseForm"
                label-position="top"
                :rules="cancelPurchaseRules"
                v-loading="cancelPurchaseModalLoading"
                @submit.prevent.native
            )
                transition(name="slide-vertical")
                    .modal-body(v-if="! cancelPurchaseModalLoading")
                        //- el-alert(
                        //-     type="info"
                        //-     :title="$t('Stock')"
                        //-     :description="$t('Stock is going back to the corresponding warehouse')"
                        //-     :closable="false"
                        //-     show-icon
                        //- )
                        .alert.info
                            i.el-icon-info
                            .text
                                b {{ $t('Stock management') }}
                                p {{ $t('Stock is going back to the corresponding warehouse') }}
            template(slot="footer")
                el-button(
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="closeCancelPurchaseModal"
                ) {{ $t('Dismiss') }}
                el-checkbox(
                    v-if="isRefundable"
                    v-model="cancelPurchaseForm.refund"
                    border
                    size="mini"
                    :disabled="remainingRefundAmount <= 0"
                ) {{ $t('Automatically refund {amount}', { amount: $options.filters.moneyFormat(remainingRefundAmount, form.currency) }) }}
                el-button(
                    :disabled="cancelPurchaseModalLoading"
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-check fas"
                    @click="cancelPurchase"
                ) {{ $t('Cancel irrevocably') }}

        el-drawer(
            :title="$t('Partially Cancel')"
            :visible.sync="partialCancelPurchaseDrawerVisibility"
            :wrapper-closable="false"
            :modal="true"
            size="90%"
            @closed="resetPartialCancelPurchaseDrawer"
        )
            el-form.partially-cancel(
                ref="partialCancelPurchaseForm"
                :model="partialCancelPurchaseForm"
                label-position="top"
                :rules="partialCancelPurchaseRules"
                v-loading="partialCancelPurchaseDrawerLoading"

                @submit.prevent.native
            )
                PartiallyCancelForm(
                    v-if="partialCancelPurchaseDrawerVisibility"
                    :purchase="form"
                    :form="partialCancelPurchaseForm"
                    :initializing.sync="partialCancelPurchaseDrawerLoading"
                    :visibility.sync="partialCancelPurchaseDrawerVisibility"
                )
            .drawer-footer
                .left
                    el-button(
                        size="small"
                        icon="el-icon-fa-times fas"
                        @click="closePartialCancelPurchaseDrawer"
                    ) {{ $t('Dismiss') }}
                .right.flex-row
                    el-checkbox(
                        border
                        size="small"
                        v-model="partialCancelPurchaseForm.notify"
                    ) {{ $t('Notify customer via email') }}
                    el-checkbox(
                        v-if="isRefundable && partialCancelPurchaseForm.status === 'approved'"
                        border
                        size="small"
                        v-model="partialCancelPurchaseForm.refund"
                    ) {{ $t('Automatically refund') }}
                    el-button(
                        :type="partialCancelSubmitButtonType"
                        size="small"
                        icon="el-icon-fa-check fas"
                        :loading="partialCancelPurchaseDrawerSaving"
                        :disabled="partialCancelPurchaseDrawerLoading"
                        @click="cancelPurchasedItems"
                    ) {{ partialCancelSubmitLabel }}
</template>

<i18n>
{
    "en": {
        "Automatically refund {amount}": "Automatically refund {amount}",
        "Automatically refund": "Automatically refund",
        "Save as pending": "Save as pending",
        "Approve & refund": "Approve & refund",
        "Reject": "Reject",
        "Type": "Type",
        "Status": "Status"
    },
    "de": {
        "This order belongs to a different store. Switch to that store to open it.": "Diese Bestellung gehört zu einem anderen Store. Wechseln Sie zu diesem Store, um sie zu öffnen.",
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Purchase could not be fetched.": "Bestellung konnte nicht gefunden werden.",
        "Purchase could not be saved.": "Bestellung konnte nicht gespeichert werden.",
        "Purchase saved successfully!": "Bestellung erfolgreich gespeichert!",
        "Purchase canceled successfully!": "Bestellung erfolgreich storniert!",
        "Purchase could not be canceled.": "Bestellung konnte nicht storniert werden.",
        "Purchase Not Found": "Bestellung nicht gefunden",
        "Are you sure you want to cancel this purchase?": "Soll diese Bestellung wirklich storniert werden?",
        "Cancel irrevocably": "Unwiderruflich stornieren",
        "Partially Cancel": "Teilweise stornieren",
        "Stock management": "Lagerverwaltung",
        "Stock is going back to the corresponding warehouse": "Der Bestand geht zurück in das entsprechende Lager",
        "Automatically refund {amount}": "Automatisch erstatten {amount}",
        "Automatically refund": "Automatisch erstatten",
        "Notify customer via email": "Kunden per E-Mail benachrichtigen",
        "Save as pending": "Als ausstehend speichern",
        "Approve & refund": "Genehmigen & erstatten",
        "Reject": "Ablehnen",
        "Type": "Typ",
        "Status": "Status",
        "Purchase": "Bestellung",
        "Customer": "Käufer",
        "Articles": "Artikel",
        "Messages": "Nachrichten",
        "Shopping cart": "Warenkorb",
        "Cancel": "Stornieren",
        "Edit": "In Bearbeitung",
        "Shipped": "Versendet"
    }
}
</i18n>

<script>
import _ from 'lodash';
import echo from '@/echo';
import { adminClient as apolloClient } from '@/store/apollo'

import router from '@/router';
import pinia from '@/pinia';
import { useSetupStore, useMicroservicesStore, useShopPurchaseStore } from '@/stores';
import { checkRestrictions } from '@/helpers';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import MicroserviceButton from '@/components/MicroserviceButton';
import ForeignStorePanel from '@/components/ForeignStorePanel';
import PurchaseApi from '@/extensions/shop/store/api/purchase';

// validate all fields, regardless if the corresponding component is mounted or not
import AllInputFields from './AllInputFields';
import NewPurchaseStepper from './NewPurchaseStepper';
import PartiallyCancelForm from './Partials/PartiallyCancelForm';

export default {
    name: 'Purchase',
    data() {
        return {
            // The store an order belongs to, when it is not the selected one.
            foreignStore: null,
            listRoute: { name: 'purchases' },
            error: false,
            pathNotValid: false,
            loading: false,
            saving: false,
            savingAndClose: false,
            canceling: false,
            partialCanceling: false,

            cancelPurchaseModalVisibility: false,
            cancelPurchaseModalLoading: false,
            cancelPurchaseForm: {
                refund: true,
            },
            cancelPurchaseRules: {},

            partialCancelPurchaseDrawerVisibility: false,
            partialCancelPurchaseDrawerLoading: false,
            partialCancelPurchaseDrawerSaving: false,
            partialCancelPurchaseForm: {
                items: [],
                credited_amount_net: 0,
                credited_amount: 0,
                max_credited_amount_net: 0,
                max_credited_amount: 0,
                comment: '',
                notify: true,
                refund: true,
                type: 'cancellation',
                status: 'approved',
            },
        };
    },
    components: {
        ForeignStorePanel,
        Tabs,
        Error,
        MicroserviceButton,
        AllInputFields,
        NewPurchaseStepper,
        PartiallyCancelForm,
    },
    watch: {
        partialCancelPurchaseDrawerVisibility(visible) {
            if (visible) {
                this.partialCancelPurchaseForm.notify = this.shopPurchaseStore.notifiesPurchaserByDefault;
            }
        },
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                // The store switch may be exactly what makes this record reachable,
                // so drop the "belongs to another store" panel before refetching -
                // it is checked before the content and would outlive a successful load.
                this.foreignStore = null;
                this.error = false;

                this.setInitializedFlag(false);
                this.initialize();
            }
            // Re-subscribe so the engagement channel matches the new CMS.
            this.subscribeSentEmailEngagement();
        }
    },
    computed: {
        // The Messages tab route carries a :conversationId (/sales/order/:id/messages/:id)
        // so an open conversation survives reload. Collapse it to the tab base so the tab
        // stays highlighted + its view stays mounted while switching conversations.
        activeMessagesTabPath() {
            const match = this.$route.path.match(/^(\/sales\/order\/\d+\/messages)(\/|$)/);
            return match ? match[1] : this.$route.path;
        },
        id() {
            return _.get(this.form, 'id', false);
        },
        isCancelable() {
            return !!this.id && !this.form.canceled_at && !this.form.closed_at;
        },
        isRefundable() {
            return !!this.form.payed_at && !!this.form.payment_method_service;
        },
        // vee-validate v2 pipe-string rules — each amount is capped at the
        // value the drawer pre-fills from the selected items (gross/net of
        // the picked rows, set by PartiallyCancelForm.updateCreditAmount).
        // You can never credit more than the items being cancelled are worth.
        // When nothing is selected (manual free-amount entry) there is no item
        // total, so we fall back to the order's grand_total. Element-UI rule
        // arrays would be a silent no-op here per project memory.
        partialCancelPurchaseRules() {
            const fallback = parseFloat(_.get(this.form, 'grand_total', 0)) || 0;
            const maxGross = parseFloat(_.get(this.partialCancelPurchaseForm, 'max_credited_amount', 0)) || fallback;
            const maxNet = parseFloat(_.get(this.partialCancelPurchaseForm, 'max_credited_amount_net', 0)) || fallback;
            return {
                credited_amount: `required|min_value:0|max_value:${maxGross}`,
                credited_amount_net: `required|min_value:0|max_value:${maxNet}`,
            };
        },
        // The submit button in the partial-cancel drawer adapts to the
        // selected (type, status) combo. "Cancel irrevocably" only fits
        // type=cancellation + status=approved (the legacy single-click
        // path). Everything else needs an honest verb.
        partialCancelSubmitLabel() {
            const type = _.get(this.partialCancelPurchaseForm, 'type', 'cancellation');
            const status = _.get(this.partialCancelPurchaseForm, 'status', 'approved');
            if (type === 'cancellation' && status === 'approved') return this.$t('Cancel irrevocably');
            if (status === 'pending')  return this.$t('Save as pending');
            if (status === 'approved') return this.$t('Approve & refund');
            if (status === 'rejected') return this.$t('Reject');
            return this.$t('Save');
        },
        // Red destructive styling only for actually destructive submits.
        // Pending creation and approve+refund are constructive — primary blue.
        partialCancelSubmitButtonType() {
            const type = _.get(this.partialCancelPurchaseForm, 'type', 'cancellation');
            const status = _.get(this.partialCancelPurchaseForm, 'status', 'approved');
            if (status === 'rejected') return 'danger';
            if (type === 'cancellation' && status === 'approved') return 'danger';
            return 'primary';
        },
        remainingRefundAmount() {
            return parseFloat(_.get(this.form, 'grand_total', 0)) || 0;
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.canceling || this.partialCanceling;
        },
        tabs() {
            const id = this.$route.params.id;

            let tabs = [];
            tabs.push({
                name: this.$t('Purchase'),
                path: `/sales/order/${id}/main`,
                icon: {
                    name: 'euro-sign',
                    group: 'fas'
                }
            })
            if (
                _.get(this.form, 'purchaser.email')
                || _.get(this.form, 'purchaser.customer.id')
                || _.get(this.form, 'sold_by') === 'point-of-sale'
            ) {
                tabs.push({
                    name: this.$t('Customer'),
                    path: `/sales/order/${id}/customer`,
                    icon: {
                        name: 'user-alt',
                        group: 'fas'
                    }
                })
            }
            tabs.push({
                name: this.$t('Articles'),
                path: `/sales/order/${id}/articles`,
                icon: {
                    name: 'tags',
                    group: 'fas'
                }
            })

            // Customer Communication — all email correspondence about this order.
            if (this.enabledExtensions && this.enabledExtensions.includes('communication')
                && checkRestrictions(['ex:comm', 'ex:comm:messages'])
                && this.id && !String(this.id).startsWith('new')) {
                tabs.push({
                    name: this.$t('Messages'),
                    path: `/sales/order/${id}/messages`,
                    icon: {
                        name: 'comments',
                        group: 'far'
                    }
                })
            }

            return tabs;
        },
        status() {
            return _.get(this.form, 'status.key', 'undefined');
        },
        inactive() {
            // 'closed', 'canceled'
            return ['new', 'undefined'].includes(this.status) || !this.id || this.form.canceled_at || this.form.closed_at;
        },
        statusOptionsLoeded() {
            return this.options.status.items.length && this.options.status.loading === false;
        },
        microservices() {
            const settings = this.settingValues;

            const all = _.get(this.activeCms, 'config.template.microservices') || [];
            const filtered = all.filter(el => el.component === 'Purchase');

            // eslint-disable-next-line no-unused-vars
            const data = this.form;

            let allowed = [];
            filtered.forEach(microservice => {
                let valid = true;
                try {
                    const conditions = microservice.conditions;
                    if (conditions && conditions.length) {
                        conditions.forEach(o => {
                            if (valid === false) return;

                            const { type, condition } = o;
                            switch (type) {
                                case 'eval':
                                    valid = eval(condition);
                                    break;

                                default:
                                    valid = false;
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                    valid = false;
                }

                if (valid) allowed.push(microservice);
            });

            return allowed;
        },
        microserviceButtons() {
            let microservices = {};

            this.microservices.forEach(microservice => {
                if (microservice.button) {
                    const position = _.get(microservice, 'button.position') || 'default';
                    if (!microservices[position]) microservices[position] = [];
                    microservices[position].push(microservice);
                }
            });

            return microservices;
        },
        setupStore() {
            return useSetupStore();
        },
        microservicesStore() {
            return useMicroservicesStore();
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        settingValues() {
            return this.setupStore.settingValues;
        },
        shopPurchaseStore() {
            return useShopPurchaseStore(pinia);
        },
        form() {
            return this.shopPurchaseStore.form;
        },
        options() {
            return this.shopPurchaseStore.options;
        },
        initialized() {
            return this.shopPurchaseStore.formInitialized;
        },
        validateOnEnter() {
            return this.shopPurchaseStore.formValidateOnEnter;
        },
        rules() {
            return this.shopPurchaseStore.rules;
        },
    },
    methods: {
        reopenAfterStoreSwitch() {
            this.foreignStore = null;
            this.error = false;
            this.initialize();
        },
        goToPurchaseList() {
            router.push({ name: 'purchases' });
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.setInitializedFlag(true);
                return;
            }

            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                const fetchDependencies = () => {
                    let actions = [
                        this.fetchShippingMethodOptions(this.activeCms.shop.id),
                        this.fetchPaymentMethodOptions(this.activeCms.shop.id),
                        this.fetchStatusOptions(this.activeCms.shop.id),
                        this.fetchIndicatorOptions(),
                        // this.fetchCategoryOptions(this.activeCms.id),
                        this.fetchStockOptions(this.activeCms.shop.id),
                        this.fetchTaxOptions(this.activeCms.shop.id),

                        this.fetchCustomerGroupOptions(this.activeCms.shop.id),
                        this.fetchTagOptions(this.activeCms.id),
                    ];

                    if (this.$route.params.id !== 'new') {
                        this.definePurchasedItemsPaginationSizes([5, 10, 50]);
                        this.definePurchasedItemsPerPage(10);
                        actions.push(
                            this.fetchPurchasedItemsPaginated({
                                scope: 'ex',
                                type: 'shop_purchase_article',
                                includeInternals: true,
                                includeWebShopPurchases: true,
                                includePointOfSalePurchases: true,
                            }).finally(() => {
                                this.updatePurchasedItemsLoading(false);
                            })
                        );
                    }

                    return Promise.all(actions);
                }

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    // this.leave();

                    const purchaser = _.cloneDeep(this.form.purchaser)
                    this.shopPurchaseStore.reset();
                    if (purchaser) this.shopPurchaseStore.setFormPurchaser(purchaser);

                    fetchDependencies()
                        .catch(handleDependencyError)
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.fetchPurchase(this.$route.params.id)
                        .then(() => {
                            // this.shopPurchaseStore.resetUI();

                            this.loading = false;

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    this.shopPurchaseStore.resetRules();
                                    // this.shopPurchaseStore.resetUI();
                                })
                                .catch(handleDependencyError);
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    // Refused because a different store is selected? The
                                    // refusal carries that store, so the switch can be
                                    // offered without asking the API a second time.
                                    this.foreignStore = _.get(graphQLErrors, '0.extensions.store') || null;
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Purchase Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Purchase could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        resetCancelPurchaseModal() {
            this.cancelPurchaseForm.refund = true;
            this.form.refund = false;
            this.$refs.cancelPurchaseForm.resetFields();
        },
        closeCancelPurchaseModal() {
            this.cancelPurchaseModalVisibility = false;
        },
        resetPartialCancelPurchaseDrawer() {
            this.partialCancelPurchaseForm = {
                items: [],
                credited_amount_net: 0,
                credited_amount: 0,
                max_credited_amount_net: 0,
                max_credited_amount: 0,
                comment: '',
                notify: true,
                refund: true,
                type: 'cancellation',
                status: 'approved',
            };

            if (this.$refs.partialCancelPurchaseForm) {
                this.$refs.partialCancelPurchaseForm.resetFields();
            }
        },
        // Always reset on close so the next open starts clean — without this,
        // the previously submitted items/comment/reason stayed in
        // partialCancelPurchaseForm and the user could accidentally re-submit
        // them on a fresh return.
        closePartialCancelPurchaseDrawer() {
            this.partialCancelPurchaseDrawerVisibility = false;
            this.resetPartialCancelPurchaseDrawer();
        },
        // eslint-disable-next-line
        microserviceError({ key, error, callback }) {
            const callbacks = {
                refetchLogs: this.refetchLogs,
                refetch: this.refetch,
                // ...
            };

            // run callback
            if (callback)
                callbacks[callback]().finally(() => this.microservicesStore.updateProcessing({ key, status: false }));
            else this.microservicesStore.updateProcessing({ key, status: false });
        },
        // eslint-disable-next-line
        microserviceSuccess({ key, error, callback }) {
            const callbacks = {
                refetchLogs: this.refetchLogs,
                refetch: this.refetch,
                // ...
            };

            setTimeout(() => {
                // run callback
                if (callback) {
                    callbacks[callback]().finally(() => this.microservicesStore.updateProcessing({ key, status: false }));
                } else {
                    this.microservicesStore.updateProcessing({ key, status: false });
                }
            }, 1000)

            // this.editPurchase()
        },
        async refetch() {
            await apolloClient.clearStore()
            await new Promise(resolve => setTimeout(resolve, 0));

            return this.fetchPurchase(this.$route.params.id)
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    } else {
                        this.error = true;
                    }

                    switch (code) {
                        case 401:
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        case 404:
                            this.error = { code, message: 'Purchase Not Found' };
                            break;
                        default:
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Purchase could not be fetched.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            break;
                    }

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                });
        },
        cancelPurchase() {
            var shouldRefund = this.cancelPurchaseForm.refund;
            this.closeCancelPurchaseModal();

            const previousStatus = _.get(this.form, 'status');

            const status = this.options.status.items.find(el => el.key === 'canceled');
            if (status) this.setStatus(status);

            if (shouldRefund) this.form.refund = true;

            this.submit('cancel')
                .catch(() => {
                    this.setStatus(previousStatus)
                });

            // this.delete(this.id)
            //     .then(() => {
            //         // this.canceling = false
            //
            //         router.push(this.listRoute)
            //
            //         this.$notify.success({
            //             title: this.$t('Purchase deleted successfully!'),
            //             iconClass: 'fas el-icon-fa-check',
            //             position: 'bottom-left',
            //             customClass: 'dark',
            //             duration: 8000,
            //         })
            //     })
            //     .catch(err => {
            //         [> eslint no-console: ["error", { allow: ["error"] }] <]
            //         console.error(err)
            //
            //         this.canceling = false
            //
            //         this.$notify.error({
            //             title: this.$t('An error occurred!'),
            //             message: this.$t('Purchase could not be deleted.'),
            //             iconClass: 'fas el-icon-fa-times',
            //             position: 'bottom-left',
            //             customClass: 'dark',
            //             duration: 8000,
            //         })
            //     })
        },
        cancelPurchasedItems() {
            // Block submit when the credited-amount inputs are out of range
            // (e.g. larger than remaining_refundable). The el-form rules
            // already render inline errors; this guard prevents the API call.
            const partialCancelForm = this.$refs.partialCancelPurchaseForm;
            if (partialCancelForm && typeof partialCancelForm.validate === 'function') {
                return partialCancelForm.validate((valid) => {
                    if (!valid) return;
                    this.$_cancelPurchasedItemsProceed();
                });
            }
            return this.$_cancelPurchasedItemsProceed();
        },
        $_cancelPurchasedItemsProceed() {
            this.partialCancelPurchaseDrawerSaving = true;

            // max_credited_amount* are UI-only validation caps and are not part
            // of CO_CancellationInput — strip them before sending the mutation.
            let cancellation = _.omit(this.partialCancelPurchaseForm, ['max_credited_amount', 'max_credited_amount_net']);
            cancellation.purchase = { id: this.form.id }

            return PurchaseApi.cancelPurchasedItems(cancellation)
                .then(async cancellation => {
                    await apolloClient.clearStore();

                    const fetchPurchase = this.fetchPurchase(this.$route.params.id)
                    const fetchPurchasedItems = this.fetchPurchasedItemsPaginated({
                        scope: 'ex',
                        type: 'shop_purchase_article',
                        includeInternals: true,
                        includeWebShopPurchases: true,
                        includePointOfSalePurchases: true,
                    })

                    return Promise.all([fetchPurchase, fetchPurchasedItems])
                        .then(() => {
                            this.closePartialCancelPurchaseDrawer();
                            this.partialCancelPurchaseDrawerSaving = false;
                        })
                        .finally(() => {
                            this.partialCancelPurchaseDrawerSaving = false;
                        });
                })
                .catch(() => {
                    this.partialCancelPurchaseDrawerSaving = false;
                });
        },
        // Real-time engagement updates: the Pusher channel pushes a single
        // sentEmail snapshot whenever any tracking field changes upstream.
        // We patch the loaded purchase in place — no refetch, no flicker.
        subscribeSentEmailEngagement() {
            this.unsubscribeSentEmailEngagement();

            if (!echo.client) {
                this.engagementChannelRetry = setTimeout(
                    () => this.subscribeSentEmailEngagement(),
                    150
                );
                return;
            }

            const cmsId = _.get(this.activeCms, 'id');
            if (!cmsId) return;

            this.engagementChannel = echo.client
                .private(`cms.${cmsId}`)
                .listen('.sent-email:engagement-updated', snapshot => {
                    this.shopPurchaseStore.patchSentEmail(snapshot);
                });
            this.engagementChannelCmsId = cmsId;
        },
        unsubscribeSentEmailEngagement() {
            if (this.engagementChannelRetry) {
                clearTimeout(this.engagementChannelRetry);
                this.engagementChannelRetry = null;
            }
            if (this.engagementChannel && this.engagementChannelCmsId && echo.client) {
                this.engagementChannel.stopListening('.sent-email:engagement-updated');
                echo.client.leave(`cms.${this.engagementChannelCmsId}`);
                this.engagementChannel = null;
                this.engagementChannelCmsId = null;
            }
        },
        async submit(event, redirect = false) {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate((valid, errors) => {
                    if (valid) {
                        if (redirect) this.savingAndClose = true;
                        else if (event === 'cancel') this.canceling = true;
                        else this.saving = true;

                        let data = _.cloneDeep(this.form);
                        if (event === 'cancel') {
                            data = {
                                id: this.form.id,
                                status: this.form.status,
                                refund: this.form.refund || false,
                            }
                        }

                        this.update(data)
                            .then(() => {
                                if (redirect) this.savingAndClose = false;
                                else if (event === 'cancel') this.canceling = false;
                                else this.saving = false;

                                if (event === 'cancel') {
                                    let notification = {
                                        title: this.$t('Purchase canceled successfully!'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    };
                                    this.$notify.warning(notification);
                                } else {
                                    let notification = {
                                        title: this.$t('Purchase saved successfully!'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    };
                                    this.$notify.success(notification);
                                }

                                if (redirect) router.push(redirect);
                                resolve();
                            })
                            .catch(err => {
                                /* eslint no-console: ["error", { allow: ["error"] }] */
                                console.error(err);

                                if (redirect) this.savingAndClose = false;
                                else if (event === 'cancel') this.canceling = false;
                                else this.saving = false;

                                let notification = {
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Purchase could not be saved.'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                };
                                if (event === 'cancel') {
                                    notification = {
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Purchase could not be canceled.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    };
                                }
                                this.$notify.error(notification);

                                reject(err);
                            });
                    } else {
                        this.setValidateOnEnterFlag(true);

                        // check the invalid fields
                        // and go to the corresponding tab
                        // or open the corresponding closed area
                        // TODO: scroll to invalid field

                        let invalidTabs = [];
                        _.each(errors, (error, path) => {
                            if (_.indexOf(['name'], path) >= 0) {
                                invalidTabs.push(`/sales/order/${this.$route.params.id}/main`);
                            }
                        });

                        invalidTabs = _.uniq(invalidTabs);

                        // check if the current tab
                        // is present in invalidTabs
                        // if not, go to next (first) invalid tab

                        const match = _.indexOf(invalidTabs, this.$route.fullPath);

                        // let switchTab = false;
                        if (match < 0) {
                            invalidTabs.every(invalidTab => {
                                if (invalidTab && this.activeTab !== invalidTab) {
                                    const tab = _.find(this.tabs, { path: invalidTab });
                                    if (tab) {
                                        this.activateTab(tab);

                                        // break loop after the first tab has been activated
                                        return false;
                                    }
                                }
                            });
                        }

                        // // triger the validation again
                        // // so the previously hidden fields will get the errors
                        // // ---
                        // // does not work if the component has been destroyed
                        // // in the meantime (f.a. by switching tabs)
                        // if (switchTab === false) {
                        //     const form = this.$refs.form
                        //     setTimeout(() => {
                        //         form.validate(() => {
                        //             // do nothing
                        //             // callback function is required :(
                        //         })
                        //     }, 1000);
                        // }

                        this.$notify.warning({
                            title: this.$t('Form is not valid!'),
                            message: this.$t('Correct your input and submit again.'),
                            iconClass: 'fas el-icon-fa-exclamation-circle',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });

                        reject('invalid');
                    }
                });
            });
        },
        editPurchase() {
            // update status to 'processing'
            const previousStatus = _.get(this.form, 'status');

            const status = this.options.status.items.find(el => el.key === 'processing');
            if (status) {
                this.setStatus(status);
                this.submit()
                    .catch(() => {
                        this.setStatus(previousStatus)
                    });
            }
        },
        shipPurchase() {
            // update status to 'shipped'
            const previousStatus = _.get(this.form, 'status');

            const status = this.options.status.items.find(el => el.key === 'shipped');
            if (status) {
                this.setStatus(status);
                this.submit()
                    .catch(() => {
                        this.setStatus(previousStatus)
                    });
            }
        },
        leave() {
            router.push(this.listRoute);
        },
        setInitializedFlag(value) {
            this.shopPurchaseStore.setFormInitialized(value);
        },
        setValidateOnEnterFlag(value) {
            this.shopPurchaseStore.setFormValidateOnEnter(value);
        },
        setStatus(value) {
            this.shopPurchaseStore.setFormStatus(value);
        },
        updatePurchasedItemsLoading(value) {
            this.shopPurchaseStore.updatePurchasedItemsPaginationLoading(value);
        },
        definePurchasedItemsPaginationSizes(value) {
            this.shopPurchaseStore.definePurchasedItemsPaginationSizes(value);
        },
        definePurchasedItemsPerPage(value) {
            this.shopPurchaseStore.definePurchasedItemsPerPage(value);
        },
        activateTab(item) {
            return this.setupStore.activateTab(item);
        },
        fetchPurchase(id) {
            return this.shopPurchaseStore.fetchPurchase(id);
        },
        refetchLogs() {
            return this.shopPurchaseStore.refetchLogs();
        },
        fetchStatusOptions(shopId) {
            return this.shopPurchaseStore.fetchStatusOptions(shopId);
        },
        fetchIndicatorOptions() {
            return this.shopPurchaseStore.fetchIndicatorOptions();
        },
        fetchStockOptions(shopId) {
            return this.shopPurchaseStore.fetchStockOptions(shopId);
        },
        fetchShippingMethodOptions(shopId) {
            return this.shopPurchaseStore.fetchShippingMethodOptions(shopId);
        },
        fetchTaxOptions(shopId) {
            return this.shopPurchaseStore.fetchTaxOptions(shopId);
        },
        fetchPaymentMethodOptions(shopId) {
            return this.shopPurchaseStore.fetchPaymentMethodOptions(shopId);
        },
        fetchCustomerGroupOptions(shopId) {
            return this.shopPurchaseStore.fetchCustomerGroupOptions(shopId);
        },
        fetchTagOptions(cmsId) {
            return this.shopPurchaseStore.fetchTagOptions(cmsId);
        },
        update(purchase) {
            return this.shopPurchaseStore.update(purchase);
        },
        fetchPurchasedItemsPaginated(payload) {
            return this.shopPurchaseStore.fetchPurchasedItemsPaginated(payload);
        },
    },
    mounted() {
        this.initialize();
        this.$root.$on('save', () => {
            this.submit()
        })
        this.subscribeSentEmailEngagement();
    },
    beforeRouteEnter(to, from, next) {
        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new';

        if (to.name === 'purchase-form' && id !== 'new') {
            next({ name: 'purchase-main', params: { id } });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        setTimeout(() => {
            this.shopPurchaseStore.reset();
            this.shopPurchaseStore.resetUI();
            this.$nextTick(() => this.shopPurchaseStore.resetRules());
        }, 300);
    },
    destroyed() {
        // console.log('destroyed');
        // geht nicht .. leert das Formular bei klick auf anderen Reiter
        // this.shopPurchaseStore.reset();
        this.unsubscribeSentEmailEngagement();
    }
};
</script>

<style lang="sass" scoped>
.foreign-store
    max-width: 520px
    margin: 60px auto
    text-align: center

    &__icon
        font-size: 28px
        color: #E6A23C
        margin-bottom: 12px

    &__title
        font-size: 16px
        font-weight: 600
        margin-bottom: 8px

    &__text
        color: #606266
        font-size: 13px
        line-height: 1.5
        margin-bottom: 18px

    &__actions
        display: flex
        justify-content: center
        gap: 10px
</style>

<style lang="sass" scoped>
.purchase::v-deep
    .el-card.no-padding
        .el-card__body
            padding: 0
            & > section
                padding: 20px
    .title
        font-weight: 400
        margin: 0
        margin-bottom: 10px
        .small
            font-size: .8em
            color: $--color-info
    .bordered-table
        // width: 500px
        .min
            width: 1px
        .centered-text
            text-align: center
        .el-icon-warning,
        .el-icon-warning-outline
            margin-right: 6px
            min-width: 1rem
            line-height: 1
            color: $--color-danger
        .flex-vertical-middle
            display: flex
            align-items: center
        .gray
            color: darken($color-grey-text, 10%)
        .danger
            color: $--color-danger
        hr
            margin: 0
    .purchase-form-main .bordered-table
        td
            padding: 8px 0
    table.bordered-table.panel
        font-size: 14px
        width: 100%
        flex-basis: 300px
        place-self: flex-start
        background: $color-body
        border-color: transparent
        border-radius: 4px
        td
            border-color: transparent
            padding: 6px 15px
        tr:first-of-type
            td
                padding-top: 10px
        tr:last-of-type
            td
                padding-bottom: 10px
        .el-loading-mask
            background-color: rgba($color-body, .8)
        .spinner
            position: absolute
            left: calc(50% - 13px)
            top: calc(50% - 18px)
            z-index: 3000

    +res(lg)
        table.bordered-table + .grow
            margin-top: 0
            margin-left: 20px
    .flex
        +res(lg)
            display: flex
        table.bordered-table + .grow
            margin-top: 36px
        .grow
            flex-grow: 1
            place-self: flex-start
            width: 100%

    .preview .annotationLayer
        display: none !important

    .el-timeline-item.success
        .el-timeline-item__tail
            border-color: $--color-success
    .el-timeline-item.half-success
        .el-timeline-item__tail:before
            content: ''
            position: absolute
            left: -2px
            top: 0
            height: 50%
            width: 2px
            background: $--color-success
            border-radius: 2px
    .el-timeline-item.bottom-half-success
        .el-timeline-item__tail:before
            content: ''
            position: absolute
            left: -2px
            bottom: 0
            height: 50%
            width: 2px
            background: $--color-success
            border-radius: 2px

.buttons-flex .delete-button
    margin-right: 20px

.modal-body
    .alert
        display: flex
        align-items: center
        margin: 0
        i
            opacity: 0.6
            min-width: 2rem
            font-size: 1.4rem

.cancel-purchase-dialog::v-deep .el-dialog__footer
    display: flex
    align-items: center
    .el-button:first-child
        margin-right: auto
    .el-checkbox.is-bordered
        margin-left: 0
        margin-right: 10px

.microservice-button-container + .el-button
    margin-left: 10px

.el-form.partially-cancel
    display: flex
    flex-direction: column

.drawer-footer .el-checkbox
    margin-right: 0
    &.is-bordered + .el-checkbox.is-bordered
        margin-left: 0
</style>
